import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=6c3c81b2&scoped=true&"
import script from "./SectionContainer.vue?vue&type=script&lang=ts&"
export * from "./SectionContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SectionContainer.vue?vue&type=style&index=0&id=6c3c81b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c81b2",
  null
  
)

export default component.exports